// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 10) return "static/css/10.1f94a0116067c7784c23.lib.css";
	if (chunkId === 632) return "static/css/632.4a62c2ee3bddda1f8f62.css";
	// return url for filenames based on template
	return undefined;
};